import { formatPrice } from "@flicket/utils";
import { ProductPriceRange } from "../sdk";

export const renderPriceRange = (
  priceRange: ProductPriceRange,
  currency?: string
) =>
  [
    ...new Set([
      priceRange.minVariantPrice.amount,
      priceRange.maxVariantPrice.amount,
    ]),
  ]
    .map((price: number) => `${formatPrice(price, { currency })}`)
    .join(" - ");
